import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted } from "vue";
import LearningCourseForm from "@/components/learning/LearningCourseForm.vue";
import { LearningCourseLogic } from "@/logic/learning/LearningCourseLogic";
import { QuestionCategoryLogic } from "@/logic/question/QuestionCategoryLogic";
import { QusitionState } from "@/state/QusitionState";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const projectId = computed(() => Number(route.params.project_id));
const { learningCourse, learningForms,
  learningCourseLoading,
  addLearningForm,
  removeLearningForm,
  create,
  getRandQuestion,
  syncLearningForm,
  addAnswerFrom,
  up, down,
  setQuillRef,
  removeAnswerForm } = LearningCourseLogic();
const { loadQuestionCategories, questionCategoryLoading } = QuestionCategoryLogic();
const questionCategories = computed(() => QusitionState.state.questionCategories);
onMounted(async (): Promise<void> => {
  QusitionState.setProjectId(projectId.value);
  loadQuestionCategories();
});
const save = async () => {
  const ret = await create()
  if (ret !== false) {
    router.push({name: 'ProjectLearningCourseShow', params: {learning_course_id: ret.id}});
  }
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(LearningCourseForm, {
        modelValue: _unref(learningCourse).name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(learningCourse).name) = $event)),
        learningForms: _unref(learningForms),
        questionCategories: _unref(questionCategories),
        onSetQuillRef: _unref(setQuillRef),
        onAddLearningForm: _unref(addLearningForm),
        onRemoveLearningForm: _unref(removeLearningForm),
        onAddAnswerFrom: _unref(addAnswerFrom),
        onRemoveAnswerForm: _unref(removeAnswerForm),
        onGetRandQuestion: _unref(getRandQuestion),
        onSyncLearningForm: _unref(syncLearningForm),
        onUp: _unref(up),
        onDown: _unref(down),
        onSave: save,
        formType: "new"
      }, null, 8, ["modelValue", "learningForms", "questionCategories", "onSetQuillRef", "onAddLearningForm", "onRemoveLearningForm", "onAddAnswerFrom", "onRemoveAnswerForm", "onGetRandQuestion", "onSyncLearningForm", "onUp", "onDown"])
    ])
  ], 512)), [
    [_directive_loading, _unref(learningCourseLoading) || _unref(questionCategoryLoading)]
  ])
}
}

})